
import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import Header from './components/Header';
import Welcome from './components/Welcome';
import About from './components/About';
import Examples from './components/Examples';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { ThemeContext } from './context/ThemeContext';
import { LanguageContext } from './context/LanguageContext';
import { content } from './content';

const App = () => {
  const { theme } = useContext(ThemeContext);
  const { language } = useContext(LanguageContext);
  const siteContent = content[language];

  return (
    <div className={`min-h-screen ${theme === 'dark' ? 'dark' : ''}`}>
      <Helmet>
        <title>{siteContent.seo.title}</title>
        <meta name="description" content={siteContent.seo.description} />
        <meta name="keywords" content={siteContent.seo.keywords.join(', ')} />
        <html lang={language} />
      </Helmet>
      <Header />
      <main>
        <Welcome />
        <About />
        <Examples />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default App;
